import { withStateHandlers } from 'recompose';

import { BreadcrumbsDropdown as BCDC } from './BreadcrumbsDropdown';

const enhance = withStateHandlers(
  { isVisible: false },
  {
    onToggle: ({ isVisible }) => e => {
      e && e.preventDefault();

      return { isVisible: !isVisible };
    },
  },
);

export const BreadcrumbsDropdown = enhance(BCDC);
